import React from "react";
import DishPhotoCard from "../../dish/components/DishPhotoCard";
import { timeConverter } from "../../../utils/timeConverter";
import CreateRsvpForm from "./CreateRsvpForm";
import AllergenIcon from "../../../components/AllergenIcon";

const MiqaatCard = ({ miqaat }) => {

    const showModal = () => {
        const modal = document.querySelector('.rsvpModalParent')
        modal.style.visibility = 'visible'
    };

    const closeModal = () => {
        const modal = document.querySelector('.rsvpModalParent')
        modal.style.visibility = 'hidden'
    };

    // Get all unique allergens from the menu dishes
    const getAllergens = () => {
        if (!miqaat.menu || miqaat.menu.length === 0) {
            return [];
        }

        const allAllergens = miqaat.menu.reduce((acc, dish) => {
            if (dish.allergens && dish.allergens.length > 0) {
                return [...acc, ...dish.allergens];
            }
            return acc;
        }, []);

        // Return unique allergens
        return [...new Set(allAllergens)];
    };

    // Get aggregated calorie range from the menu dishes
    // Assumes 8oz servings (half of the base 16oz) since people eat smaller portions of multiple dishes
    const getCalorieRange = () => {
        if (!miqaat.menu || miqaat.menu.length === 0) {
            return null;
        }

        const validCalories = miqaat.menu
            .filter(dish => dish.calories && dish.calories.min > 0 && dish.calories.max > 0)
            .map(dish => dish.calories);

        if (validCalories.length === 0) {
            return null;
        }

        // Sum max calories and divide by 2 for 8oz servings
        const totalMax = Math.round(validCalories.reduce((sum, cal) => sum + cal.max, 0) / 2);
        const totalMin = totalMax - 300;

        return { min: totalMin, max: totalMax };
    };

    const allergens = getAllergens();
    const calorieRange = getCalorieRange();

    return (
        <>
            <div className="rsvpModalParent">
                <div className="modalSuccessful">
                    <h3>RSVP Successful!</h3>
                    <button className='ok' onClick={closeModal}><p>Close</p></button>
                </div>
            </div>
            <div className="miqaatRow">
                <div className="miqaatTitle">
                    <p><b>{miqaat.title}</b></p>
                </div>
                {
                    miqaat.image &&
                    <>
                        <DishPhotoCard image={miqaat.image}
                            dish={miqaat}
                            style={{ paddingBottom: '0px' }}
                            radius={"0"}
                            height={"224"}
                            width={"362"}
                        />
                    </>
                }
                <p><b>{miqaat.hijriDate}</b></p>
                <p><b>{timeConverter(miqaat.date)}, {miqaat.time}</b></p>
                <p style={{ textAlign: "center" }}>
                    <b>{miqaat.program}</b>
                    <span style={{ position: "relative", top: "-6px", marginLeft: "2px", display: "inline-block", verticalAlign: "super" }}>
                        <AllergenIcon allergens={allergens} calories={calorieRange} showServingSize={false} />
                    </span>
                </p>
                <hr className="miqaatRowLine" />
                <div style={{ height: "30%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <p style={{ textAlign: "center", padding: "5px", fontSize: "14px", lineHeight: "1.5rem" }}>
                        {miqaat.description}
                    </p>
                </div>
                <CreateRsvpForm miqaat={miqaat} showModal={showModal} />
                <hr className="miqaatRowLine" />
                <div className="hostsDiv">
                    <p style={{ fontSize: "14px" }}>
                        Hosts: {miqaat.isCommittee ? "Niyaaz Committee" : miqaat.hosts.map(host => host.fullName).join(", ")}
                    </p>
                </div>
            </div>
        </>
    )
}

export default MiqaatCard;
